import { render, staticRenderFns } from "./PersonnelUser.vue?vue&type=template&id=4dc971aa"
import script from "./PersonnelUser.vue?vue&type=script&lang=js"
export * from "./PersonnelUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports